import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The server send gate (docs/plans/2026-10-23-feat-correspondence-server-send-plan.md, U3a), spread
 * into FEATURE_GATE_SEEDS in feature-gate-registry.ts at its place in the admin page order. The row
 * is created by the send_draft_gate_and_sweeper migration.
 */
export const SERVER_SEND_FEATURE_GATE_SEEDS = {
  correspondence_server_send: {
    label: 'Server send',
    shortLabel: 'Server send',
    description:
      'Sends a saved draft from the server instead of the browser, so a send finishes even if the tab closes and the web and iPhone apps send the same way. Not a sidebar item; off means every send takes the existing browser path.',
    group: 'correspondence',
  },
} satisfies Record<string, FeatureGateSeed>;
